import React from 'react'
import './PageHero.scss'

const PageHero = ({ sectionTitle, sectionDescription }) => {
  return (
    <section className='page-hero'>
      <div className="container">
        <h1 className='section-title'>{sectionTitle}</h1>
        <div className='section-description'>
          {sectionDescription}
        </div>
      </div>
    </section>
  )
}

export default PageHero